<script>
    import { getContext } from 'svelte'; const dispatch = getContext('dispatch');
    export let unInterrupt = false;
    export let message = null;
    export let tooltip = null;
    export let style = '';
    export let href = null;
    const onClick = (e) => {
        if (message != null) {
            e.preventDefault();
            e.stopPropagation();
            dispatch(message);
        }
    };
</script>


<a href="{href ?? '#'}" {style} class:unInterrupt title={tooltip} on:click={onClick}><slot/></a>


<style lang="less">
    @import "./common.less";
    a {
        color: @buttonTextColor;
        font-weight: normal;
    }
    a :global(path.stroke) {
        stroke: @buttonTextColor;
    }
    a :global(path.fill) {
        fill: @buttonTextColor;
    }
    a:hover {
        color: @brightFg;
        background-color: @buttonHoverColor;
    }
    a:hover :global(path.stroke) {
        stroke: @brightFg;
    }
    a:hover :global(path.fill) {
        fill: @brightFg;
    }
    a {
        flex: 1 0 0;
        display: block;
        padding: 6px 15px;
        margin: 0;
        font-size: inherit;
        text-decoration: none;
        background: @buttonColor;
        border: 1px solid @buttonBorderColor;
        border-radius: 8px;
        display: grid;
        align-items: center;
    }
    a.unInterrupt {
        background-color: #ffd401;
        border: 1px solid #ffd401;
        color: black;
        font-family: orbitron;
    }
    a.unInterrupt:hover {
        color: black;
        background-color: #ffde3a;
    }
</style>